function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, $helpers, JSON, Object, customRangeType, fromDate, requestAnimationFrame, toDate, unit, value) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'date-range-picker': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((customRangeType === $helpers.CUSTOM_RANGE_TYPES.RELATIVE || customRangeType === $helpers.CUSTOM_RANGE_TYPES.RELATIVE_FUTURE || customRangeType === $helpers.CUSTOM_RANGE_TYPES.RELATIVE_BEFORE_IN_PAST) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'relative-range-picker': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("input", {
              "attrs": __vjadeStringifyAttrsIfObj({
                type: 'text',
                value,
              }),
              "on": {
                change: ev => ev.stopPropagation(),
                input: $helpers.changedRelativeRangeValue,
              },
              "hook": {
                insert: vnode => requestAnimationFrame(() => vnode.elm.select())
              },
              "class": {
                'relative-range-value': true
              },
            }));
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": __vjadeStringifyAttrsIfObj({
                options: JSON.stringify(Object.values($helpers.UNITS).map(unit => $helpers.pluralize(unit))),
                'selected-option': $helpers.pluralize(unit),
                'label-transform': `uppercase`,
                'menu-width': 90,
              }),
              "on": {
                change: $helpers.changedRelativeRangeUnit,
              },
            }));
            __jade_nodes = __jade_nodes.concat((customRangeType === $helpers.CUSTOM_RANGE_TYPES.RELATIVE_BEFORE_IN_PAST) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'relative-range-ago': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("ago");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("cohorts-calendar-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              from: fromDate,
              'is-range': customRangeType === $helpers.CUSTOM_RANGE_TYPES.BETWEEN,
              'min-days-apart': 1,
              preposition: $component.getAttribute(`preposition`) || `to`,
              to: toDate,
            }),
            "on": {
              change: $helpers.changedDates,
            },
            "key": customRangeType,
            "hook": {
              insert: $helpers.handleInsertCalendarInput
            },
          }));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "customRangeType" in locals ? locals.customRangeType : typeof customRangeType !== "undefined" ? customRangeType : undefined, "fromDate" in locals ? locals.fromDate : typeof fromDate !== "undefined" ? fromDate : undefined, "requestAnimationFrame" in locals ? locals.requestAnimationFrame : typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : undefined, "toDate" in locals ? locals.toDate : typeof toDate !== "undefined" ? toDate : undefined, "unit" in locals ? locals.unit : typeof unit !== "undefined" ? unit : undefined, "value" in locals ? locals.value : typeof value !== "undefined" ? value : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;